import React from "react";

import * as S from "./styles";

const Footer: React.FC = () => {
  return (
    <S.Container>
      <S.Text
        className="wow animate__animated animate__fadeIn"
        data-wow-duration="1s"
      >
        Aliás, renovar-se é o seu lema. “A vida não é penitência. Se a gente
        pode trocar de marido, por que não pode trocar de amigos?”, questiona,
        dando risada. Sobre amizade, Thai não tem papas na língua: se for para
        deixar para baixo ou puxar para trás, não há razão para insistir. “As
        pessoas, às vezes, se deixam ficar presas. ‘Tem que ser amiga da
        fulaninha’... Não tem não! Adoro entrar em novos círculos de novas
        pessoas com novas ideias”, opina. Quando o assunto é amor, vale o mesmo,
        mas com um adendo importante. “Acho que a base de qualquer tipo de amor
        tem que ser o autoamor. Enquanto a gente não se ama, a gente não
        consegue amar o outro de uma forma respeitosa consigo mesmo. Quando eu
        virei essa chave, tudo melhorou: eu não amava ser mãe e passei a amar,
        meus filhos passaram a me respeitar mais… Fora isso, o que os outros
        consideram como amor não precisa ser parâmetro para mim. Eu simplifiquei
        o amor. Não forço a barra em nome dele e me mantenho atenta sempre aos
        meus limites e aos limites dos outros.”
      </S.Text>
      <S.TextSmall>
        Créditos: foto 1 - Brinco, Tiffany & Co.; foto 2 - Vestido, Cris Barros.
        Brincos, colar, anéis e pulseiras, Tiffany & Co.; foto 3- Camiseta e
        blazer, Balmain. Brincos, anéis e pulseiras, Tiffany & Co. ; foto 4-
        Camisa e calça, Isabel Marant. Brincos, anéis e pulseiras, Tiffany & Co.
        ; foto 5 - Camiseta e blazer, Balmain. Brincos, anéis e pulseiras,
        Tiffany & Co. ; foto 6 - Camisa e calça, Isabel Marant. Brincos, anéis e
        pulseiras, Tiffany & Co.; foto 7 - Blazer, Bottega Veneta. Brincos,
        anéis e pulseiras, Tiffany & Co.
      </S.TextSmall>
      <S.Title>
        Produção de moda: Diego Tofolo
        <br />
        Assistente de foto: Gael Oliveira
        <br />
        Assistente de vídeo: Isabella Barreto
        <br />
        Assistente de beleza: Juliana Bonfim
        <br />
        Manicure: Thayna Dandara
        <br />
        Produção executiva: Isabela de Paula
        <br />
        Tratamento de imagem: Thiago Auge
      </S.Title>
    </S.Container>
  );
};

export default Footer;
